import { css } from 'styled-components';

export const filterButtonStyles = css`
  color: rgba(0, 0, 0, 0.5);
  &,
  &:focus:not(:hover) {
    background-color: transparent;
  }
  ${({ selected }) =>
    selected &&
    `
      background-color: var(--active-color) !important;
      &, &:hover, &:focus, &:active {
        color: var(--text-color) !important;
        border-color: var(--overyield-blue) !important;
        font-weight: bold;
      }
      &:hover {
        background-color: var(--active-hover) !important;
      }
  `}
`;
